export default __webpack_public_path__ + "media/images/images/flags/ar-f427a116e15f7865d67d0dc907235c6e.png";